import _ from 'lodash';
import {
    COLLECTION_META_DETAIL_PROMPT, FACEBOOK_AD_TEXT_PROMPT,
    GENERIC_PROMPT, GENERIC_PROMPT_FOLLOWUP,
    PRODUCT_DESCRIPTION_META_PROMPT,
    PRODUCT_DESCRIPTION_PROMPT, PRODUCT_META_TITLE_PROMPT
} from "../constants/open-ai.constant";

export {
    prepareCollectionDescriptionMetaPromptMessages,
    prepareProductMetaTitlePromptMessages,
    prepareProductDescriptionPromptMessages,
    prepareProductDescriptionMetaPromptMessages,
    prepareFacebookAdTextPromptMessages,
    prepareGenericPromptMessages,
    prepareGenericJSONPromptMessages,
    prepareGenericFollowupJSONPromptMessages,
}

const prepareCollectionDescriptionMetaPromptMessages = (designDetail, metaDetail) => {
    return prepareCollectionDetailPromptMessages(designDetail, metaDetail, COLLECTION_META_DETAIL_PROMPT);
}

const prepareProductMetaTitlePromptMessages = (designDetail, metaDetail) => {
    return prepareProductDetailPromptMessages(designDetail, metaDetail, PRODUCT_META_TITLE_PROMPT);
}

const prepareProductDescriptionMetaPromptMessages = (designDetail, metaDetail) => {
    return prepareProductDetailPromptMessages(designDetail, metaDetail, PRODUCT_DESCRIPTION_META_PROMPT);
}


const prepareProductDescriptionPromptMessages = (designDetail, metaDetail) => {
    return prepareProductDetailPromptMessages(designDetail, metaDetail, PRODUCT_DESCRIPTION_PROMPT);
}

const prepareFacebookAdTextPromptMessages = (designDetail, count, toneOfVoice = 'Catchy') => {
    const promptData: any = {};
    promptData.tone = toneOfVoice;
    promptData.contents = designDetail.designTags.join(', ');
    promptData.count = count || 1;

    let messagesText = _.replace(JSON.stringify(FACEBOOK_AD_TEXT_PROMPT), /{TONE}/g, promptData.tone);
    messagesText = _.replace(messagesText, /{COUNT}/g, promptData.count);
    messagesText = _.replace(messagesText, /{CONTENTS}/g, promptData.contents);

    return JSON.parse(messagesText);
}

const prepareProductDetailPromptMessages = (designDetail, metaDetail, promptTemplate) => {
    const promptData: any = {};
    promptData.tone = metaDetail?.toneOfVoice || 'Trendy';
    promptData.contents = designDetail.designTags.join(', ');
    promptData.count = metaDetail.count || designDetail.variants.length || 1;
    promptData.productName = designDetail.parent;
    promptData.themeName = designDetail.themeName;
    promptData.designName = designDetail.quoteName;
    promptData.productType = designDetail.productType;

    if (designDetail.parent.indexOf('All-Over Print') > -1) {
        promptData.productName = _.trim(_.split(designDetail.parent, 'All-Over Print')[1]);
    }

    if (designDetail.themeName.indexOf('Theme') > -1) {
        promptData.themeName = _.trim(_.replace(designDetail.themeName, 'Theme', ''));
    }

    let duplicateMetaTitleContent = '';
    if (!_.isEmpty(metaDetail?.duplicateMetaTitles)) {
        duplicateMetaTitleContent = ". Exclude the following titles: '" + metaDetail.duplicateMetaTitles.join(', ') + "'.";
    }

    let messagesText = _.replace(JSON.stringify(promptTemplate), /{TONE}/g, promptData.tone);
    messagesText = _.replace(messagesText, /{COUNT}/g, promptData.count);
    messagesText = _.replace(messagesText, /{CONTENTS}/g, promptData.contents);
    messagesText = _.replace(messagesText, /{PRODUCT_NAME}/g, promptData.productName);
    messagesText = _.replace(messagesText, /{PRODUCT_TYPE}/g, promptData.productType);
    messagesText = _.replace(messagesText, /{DESIGN_NAME}/g, promptData.designName);
    messagesText = _.replace(messagesText, /{THEME_NAME}/g, promptData.themeName);
    messagesText = _.replace(messagesText, /{DUPLICATE_META_TITLES}/g, duplicateMetaTitleContent);

    return JSON.parse(messagesText);
}

const prepareCollectionDetailPromptMessages = (collection, metaDetail, promptTemplate) => {
    const promptData: any = {};
    promptData.tone = metaDetail?.toneOfVoice || 'Trendy';
    promptData.url = `https://leafyorb.com/collections/${collection?.handle}`;


    let messagesText = _.replace(JSON.stringify(promptTemplate), /{TONE}/g, promptData.tone);
    messagesText = _.replace(messagesText, /{URL}/g, promptData.url);
    messagesText = _.replace(messagesText, /{TITLE}/g, collection.title);

    return JSON.parse(messagesText);
}

const prepareGenericPromptMessages = (promptTitle, promptContent) => {
    let messagesText = _.replace(JSON.stringify(GENERIC_PROMPT), /{PROMPT_TITLE}/g, promptTitle);
    messagesText = _.replace(messagesText, /{PROMPT_CONTENT}/g, promptContent);

    return JSON.parse(messagesText);
}

const prepareGenericJSONPromptMessages = (promptTitle, promptContent) => {
    let messagesText = _.replace(JSON.stringify(GENERIC_PROMPT), /{PROMPT_TITLE}/g, promptTitle);
    const promptMessages = JSON.parse(messagesText);
    promptMessages[1].content = promptContent;

    return promptMessages;
}

const prepareGenericFollowupJSONPromptMessages = (promptTitle, promptContent, previousResponse, newPrompt) => {
    let messagesText = _.replace(JSON.stringify(GENERIC_PROMPT_FOLLOWUP), /{PROMPT_TITLE}/g, promptTitle);
    const promptMessages = JSON.parse(messagesText);
    promptMessages[1].content = promptContent;
    promptMessages[2].content = previousResponse;
    promptMessages[3].content = newPrompt;

    return promptMessages;
}
